import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const MapPage = withSuspense(
	lazy(async () => await import('./map-page.component')),
	PageLoader,
);
